/**
 * Display name for the Hired Equipment Submissions tab and related chrome.
 * Matches the HE mockup ("Hired Equipment & Subcontractors").
 */
export const HIRED_EQUIPMENT_MODULE_LABEL = 'Hired Equipment & Subcontractors';

/**
 * Form.name prefix / Submissions `formType` query value. WRAP submissions are
 * named `${HIRED_EQUIPMENT_FORM_TYPE} ${ticket}`; TrueContext HE names also
 * contain this substring. Do not change without updating the server filter.
 */
export const HIRED_EQUIPMENT_FORM_TYPE = 'Hired Equipment';
